import React, { FC, SyntheticEvent } from 'react';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { Description as DescriptionIcon } from '@material-ui/icons';
import Typography from '@material-ui/core/Typography';

import { colors } from '../../../../themes/colors';
import { TestID } from './constants';

const styles = (theme) =>
  createStyles({
    mhResourceButton: {
      backgroundColor: colors.turquoise1,
      color: 'white',
      marginRight: 10,
      '&:hover': {
        backgroundColor: colors.turquoise2,
      },
    },
  });

type Props = {
  onClick: (event: SyntheticEvent) => void;
} & WithStyles;

const ResourcesButton: FC<Props> = ({ classes, onClick }) => {
  return (
    <Button className={classes.mhResourceButton} data-testid={TestID} onClick={onClick}>
      <DescriptionIcon />

      <Typography variant="body1">Share Resources</Typography>
    </Button>
  );
};

export default withStyles(styles)(ResourcesButton);
